<div class="main-wrapper error-page">
  <div class="page-wrapper">
    <div class="page-content">
      <img alt="" [src]="IMAGES_URL + 'others/404-updated.svg'" alt="404" />
      <div class = "details">
        <h4 class="title">{{ title }}</h4>
        <h6 class="detail" [innerHTML]="desc"></h6>
      </div>
      <a class="link" routerLink="">Back to home</a>
    </div>
  </div>
</div>
